import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import * as spriteIcons from 'assets/svg/sprite'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import DocumentUploadCard from 'features/DocumentUploadCard/DocumentUploadCard'
import LayoutHeader from 'features/LayoutHeader/LayoutHeader'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import { useUserProfile } from 'store'

import DAC7 from './taxdocumentform/dac7'


export const UploadDocuments = () => {
    const { t } = useTranslation()
    const userData = useUserProfile()
    console.log(userData, 'userData')

    const usaDocs = [
        {
            type: 'w9',
            title: t('W9Form')
        }
    ] as const

    const usaeuDocs = [
        {
            type: 'w9',
            title: t('W8BENEUForm')
        }
    ] as const

    const foreignDocs = [
        {
            type: 'w8ben',
            title: t('W8BENForm')
        }
        // {
        //   type: 'w8bene',
        //   title: t('W8BENEForm'),
        // }
    ] as const

    const documents = useMemo(() => {
        // if (!userData?.country) {
        return [...usaDocs, ...foreignDocs, ...usaeuDocs]
        // }

        // return userData.country === 'US' ? usaDocs : foreignDocs;
    }, [userData?.country])

const EU_COUNTRIES = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
  'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
]

// Utility Functions
const isEUResident = (countryCode?: string) => {
  const result = EU_COUNTRIES.includes(countryCode ?? '')
  return result
}

const isUSResident = (countryCode?: string) => {
  const result = countryCode === 'US'
  return result
}

const isUSOrEUResident = (countryCode?: string) => {
  const result = isUSResident(countryCode) || isEUResident(countryCode)
  return result
}

const isNonUSEUResident = (countryCode?: string) => {
  const result = !isUSOrEUResident(countryCode)
  return result
}



    return (
        <WithHeaderSection
            headerSection={
                <LayoutHeader
                    type='basic'
                    // section={t('settings:uploadTaxDocuments')}
                    title={t('upload Tax Documents')}
                />
            }
        >
            <>
              {isUSOrEUResident(userData?.country) && (
                <ActionCard
                    icon={<spriteIcons.IconNoteOutline />}
                    iconSize='small'
                    text={t('W9Form')}
                    hasArrow
                    link='/settings/general/payout-settings/upload-documents/w9'
                />
               )}
        
                {isNonUSEUResident(userData?.country) && (
                <ActionCard
                    icon={<spriteIcons.IconNoteOutline />}
                    iconSize='small'
                    text={t('W8BENEUForm')}
                    hasArrow
                    link='/settings/general/payout-settings/upload-documents/w8bene'
                />
                )}
        
                 {isEUResident(userData?.country) && (
                <ActionCard
                    icon={<spriteIcons.IconNoteOutline />}
                    iconSize='small'
                    text={t('DAC7Form')}
                    hasArrow
                    link='/settings/general/payout-settings/upload-documents/dac7'
                />
                 )}
            
            </>
        </WithHeaderSection>
    )
}
